<template>
    <div class="alert alert-custom show m-0" :class="[alertType]" role="alert">
        <div class="alert-icon px-3">
            <slot name="icon"/>
        </div>
        <div class="alert-text d-flex flex-column justify-content-center pl-3">
            <h4 class="alert-heading mb-1 font-size-lg" v-text="title"/>
            <div>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        closable: Boolean,
        type: {
            type: String,
            default: 'info',
        },
    },

    computed: {
        alertType() {
            let alertClasses = [`alert-${this.type}`]

            if (this.closable) {
                alertClasses.push('fade')
            }

            return alertClasses.join(' ')
        },
    },
}
</script>
